<template>
  <div class="model-view">
    <ModelViewVulkan
      ref="modelViewRef"
      :modelInfo="modelInfo"
      :cloudRender="cloudRender"
      @loadModelEnd="loadModelEnd"
      @sendPlayer="sendPlayer"
    ></ModelViewVulkan>
    <BottomTool :player="player" :cloudRender="cloudRender" v-if="modelLoaded"></BottomTool>
  </div>
</template>
<script>
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import ModelViewVulkan from '../components/ModelViewVulkan'
import BottomTool from '../components/basicTabBar'

export default {
  name: 'VisualizationCockpitVulkan',
  components: {
    ModelViewVulkan,
    BottomTool,
  },
  data() {
    return {
      player: null,
      cloudRender: null,
      modelLoaded: false,
      modelPath: '',
      modelUrl: '',
      modelInfo: null
    }
  },
  async created() {
    this.cloudRender = cloudRender
    const query = this.$route.query
    this.modelInfo = query
  },
  methods: {
    async sendPlayer(player) {
      this.player = player
    },
    async loadModelEnd() {
      this.modelLoaded = true
    },
  },
}
</script>
<style lang="scss" scoped>
.model-view {
  width: 100%;
  height: 100%;
}
</style>
